/**
 * External Imports
 */
import { FC } from 'react';
import { connect, useDispatch } from 'react-redux';

/**
 * Nexus Imports
 */
import { NeuButton } from '@neutron/react';
import { useAnalyticsApi } from '@shared-web-analytics/react/dist';

/**
 * Internal Imports
 */
import { RootState } from '../../../../redux/store';
import { clearRoundState, clearRoundSurvey } from '../../../../redux/actions';
import { logRoundClick } from '../../../../utils/analyticsHelpers';

interface CancelRoundBtnProps {
  isEdit: boolean;
  type: string;
}

const CancelRoundBtn: FC<CancelRoundBtnProps> = ({ isEdit, type }) => {
  const dispatch = useDispatch();

  const { logTrackingEvent } = useAnalyticsApi();

  const handleCancelRound = () => {
    logTrackingEvent(logRoundClick('cancel', type));
    dispatch(clearRoundState());
    if (
      type === 'employee' ||
      type === 'validation' ||
      type === 'aidetValidation' ||
      type === 'bssrValidation' ||
      type === 'csc' ||
      type === 'cned'
    )
      dispatch(clearRoundSurvey());
  };

  return (
    <NeuButton
      id="Cancel-Round-Button"
      className={`mx-2${isEdit ? ' invisible' : ''}`}
      color="red"
      kind="primary"
      size="small"
      onClick={handleCancelRound}
    >
      Cancel{' '}
      {type === 'validation' ||
      type === 'aidetValidation' ||
      type === 'bssrValidation'
        ? 'Validation'
        : 'Round'}
    </NeuButton>
  );
};

const mapReduxStateToProps = (state: RootState) => ({
  authorizedUser: state.AuthorizedUser.authorizedUser
});

export default connect(mapReduxStateToProps)(CancelRoundBtn);
